<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12 p-0 m-0">
    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-12 p-0 m-0 navbar-bg">
      <div class="rappider-component">
        <!-- Component: Image 1 -->
        <rappider-image
          [source]="image_1.source"
          [alternateText]="image_1.alternateText"
          [placeholder]="image_1.placeholder"
          [disablePreview]="image_1.disablePreview"
          [borderSettings]="image_1.borderSettings"
          [shadowSettings]="image_1.shadowSettings"
          [paddingSettings]="image_1.paddingSettings"
          [marginSettings]="image_1.marginSettings"
          [customSizeSettings]="image_1.customSizeSettings"
        >
        </rappider-image>
      </div>
    </div>

    <!-- Container: Container 4 -->
    <div
      class="rappider-container container-4 col-12 hidden-mw480 navbar-bg p-0 m-0"
    >
      <!-- Container: Container 5 -->
      <div
        class="rappider-container container-5 col-3 container-spacing-settings"
      >
        <div class="rappider-component">
          <!-- Component: Image 2 -->
          <rappider-image
            [source]="image_2.source"
            [alternateText]="image_2.alternateText"
            [placeholder]="image_2.placeholder"
            [disablePreview]="image_2.disablePreview"
            [borderSettings]="image_2.borderSettings"
            [shadowSettings]="image_2.shadowSettings"
            [paddingSettings]="image_2.paddingSettings"
            [marginSettings]="image_2.marginSettings"
            [customSizeSettings]="image_2.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>

      <!-- Container: Container 6 -->
      <div
        class="rappider-container container-6 col-5 container-spacing-settings"
      >
        <div class="rappider-component select-height">
          <!-- Component: Select 3 -->
          <rappider-select
            [grouppedOptions]="select_3.grouppedOptions"
            [placeholder]="select_3.placeholder"
            [invalidConfigText]="select_3.invalidConfigText"
            [disabled]="select_3.disabled"
            [buttons]="select_3.buttons"
            [dropdownMatchSelectWidth]="select_3.dropdownMatchSelectWidth"
            [dropdownClassName]="select_3.dropdownClassName"
            [cssStyle]="select_3.cssStyle"
            [cssClass]="select_3.cssClass"
            [borderSettings]="select_3.borderSettings"
            [sizeSettings]="select_3.sizeSettings"
            [colorSettings]="select_3.colorSettings"
            [boxShadowSettings]="select_3.boxShadowSettings"
            [paddingSettings]="select_3.paddingSettings"
            [marginSettings]="select_3.marginSettings"
            [size]="select_3.size"
            [settings]="select_3.settings"
            [options]="select_3.options"
          >
          </rappider-select>
        </div>

        <div class="rappider-component input-button input-settings">
          <!-- Component: Input Group 4 -->
          <rappider-input-group
            [prefixIcon]="inputGroup_4.prefixIcon"
            [suffixIcon]="inputGroup_4.suffixIcon"
            [prefixButton]="inputGroup_4.prefixButton"
            [suffixButton]="inputGroup_4.suffixButton"
            [textbox]="inputGroup_4.textbox"
            [prefixText]="inputGroup_4.prefixText"
            [suffixText]="inputGroup_4.suffixText"
          >
          </rappider-input-group>
        </div>
      </div>

      <!-- Container: Container 7 -->
      <div
        class="rappider-container container-7 col-2 container-spacing-settings"
      >
        <div class="rappider-component">
          <!-- Component: Cart Preview  5 -->
          <rappider-cart-preview
            [cartItem]="cartPreview_5.cartItem"
            [footer]="cartPreview_5.footer"
            [footerContent]="cartPreview_5.footerContent"
            [buttons]="cartPreview_5.buttons"
            [dropdownButton]="cartPreview_5.dropdownButton"
            [placement]="cartPreview_5.placement"
            [triggerType]="cartPreview_5.triggerType"
          >
          </rappider-cart-preview>
        </div>

        <div class="rappider-component">
          <!-- Component: Cart Preview  6 -->
          <rappider-cart-preview
            [cartItem]="cartPreview_6.cartItem"
            [footer]="cartPreview_6.footer"
            [footerContent]="cartPreview_6.footerContent"
            [buttons]="cartPreview_6.buttons"
            [dropdownButton]="cartPreview_6.dropdownButton"
            [placement]="cartPreview_6.placement"
            [triggerType]="cartPreview_6.triggerType"
          >
          </rappider-cart-preview>
        </div>
      </div>

      <!-- Container: Container 8 -->
      <div class="rappider-container container-8 container-spacing-settings">
        <div class="rappider-component">
          <!-- Component: Icon 7 -->
          <rappider-icon
            [name]="icon_7.name"
            [color]="icon_7.color"
            [size]="icon_7.size"
            [type]="icon_7.type"
            [theme]="icon_7.theme"
            [animation]="icon_7.animation"
            [style]="icon_7.style"
            [secondColor]="icon_7.secondColor"
          >
          </rappider-icon>
        </div>
      </div>

      <!-- Container: Container 9 -->
      <div
        class="rappider-container container-9 col-1 container-spacing-settings"
      >
        <div class="rappider-component">
          <!-- Component: Button 8 -->
          <rappider-button
            [text]="button_8.text"
            [type]="button_8.type"
            [shape]="button_8.shape"
            [size]="button_8.size"
            [colorType]="button_8.colorType"
            [icon]="button_8.icon"
            [iconPlacement]="button_8.iconPlacement"
            [transparent]="button_8.transparent"
            [loading]="button_8.loading"
            [block]="button_8.block"
            [disabled]="button_8.disabled"
            [key]="button_8.key"
            [emitWithoutPopconfirm]="button_8.emitWithoutPopconfirm"
            [popconfirmTitle]="button_8.popconfirmTitle"
            [borderSettings]="button_8.borderSettings"
            [marginSettings]="button_8.marginSettings"
            [paddingSettings]="button_8.paddingSettings"
            [shadowSettings]="button_8.shadowSettings"
            [customColorSettings]="button_8.customColorSettings"
            [customSizeSettings]="button_8.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 9 -->
          <rappider-button
            [text]="button_9.text"
            [type]="button_9.type"
            [shape]="button_9.shape"
            [size]="button_9.size"
            [colorType]="button_9.colorType"
            [icon]="button_9.icon"
            [iconPlacement]="button_9.iconPlacement"
            [transparent]="button_9.transparent"
            [loading]="button_9.loading"
            [block]="button_9.block"
            [disabled]="button_9.disabled"
            [key]="button_9.key"
            [emitWithoutPopconfirm]="button_9.emitWithoutPopconfirm"
            [popconfirmTitle]="button_9.popconfirmTitle"
            [borderSettings]="button_9.borderSettings"
            [marginSettings]="button_9.marginSettings"
            [paddingSettings]="button_9.paddingSettings"
            [shadowSettings]="button_9.shadowSettings"
            [customColorSettings]="button_9.customColorSettings"
            [customSizeSettings]="button_9.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 10 -->
    <div
      class="rappider-container container-10 col-12 container-spacing-settings hidden-mw480 banner-svg navbar-bg"
    >
      <!-- Container: Container 11 -->
      <div class="rappider-container container-11 col-12 container">
        <!-- Container: Container 12 -->
        <div
          class="rappider-container container-12 col-2 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Dropdown Menu 10 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_10.icon"
              [placement]="dropdownMenu_10.placement"
              [triggerType]="dropdownMenu_10.triggerType"
              [items]="dropdownMenu_10.items"
              [label]="dropdownMenu_10.label"
              [labelMode]="dropdownMenu_10.labelMode"
            >
            </rappider-dropdown-menu>
          </div>
        </div>

        <!-- Container: Container 13 -->
        <div
          class="rappider-container container-13 col-5 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Dropdown Menu 11 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_11.icon"
              [placement]="dropdownMenu_11.placement"
              [triggerType]="dropdownMenu_11.triggerType"
              [items]="dropdownMenu_11.items"
              [label]="dropdownMenu_11.label"
              [labelMode]="dropdownMenu_11.labelMode"
            >
            </rappider-dropdown-menu>
          </div>
        </div>

        <!-- Container: Container 14 -->
        <div class="rappider-container container-14 col-5">
          <div class="rappider-component">
            <!-- Component: Button 12 -->
            <rappider-button
              [text]="button_12.text"
              [type]="button_12.type"
              [shape]="button_12.shape"
              [size]="button_12.size"
              [colorType]="button_12.colorType"
              [icon]="button_12.icon"
              [iconPlacement]="button_12.iconPlacement"
              [transparent]="button_12.transparent"
              [loading]="button_12.loading"
              [block]="button_12.block"
              [disabled]="button_12.disabled"
              [key]="button_12.key"
              [emitWithoutPopconfirm]="button_12.emitWithoutPopconfirm"
              [popconfirmTitle]="button_12.popconfirmTitle"
              [borderSettings]="button_12.borderSettings"
              [marginSettings]="button_12.marginSettings"
              [paddingSettings]="button_12.paddingSettings"
              [shadowSettings]="button_12.shadowSettings"
              [customColorSettings]="button_12.customColorSettings"
              [customSizeSettings]="button_12.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 13 -->
            <rappider-button
              [text]="button_13.text"
              [type]="button_13.type"
              [shape]="button_13.shape"
              [size]="button_13.size"
              [colorType]="button_13.colorType"
              [icon]="button_13.icon"
              [iconPlacement]="button_13.iconPlacement"
              [transparent]="button_13.transparent"
              [loading]="button_13.loading"
              [block]="button_13.block"
              [disabled]="button_13.disabled"
              [key]="button_13.key"
              [emitWithoutPopconfirm]="button_13.emitWithoutPopconfirm"
              [popconfirmTitle]="button_13.popconfirmTitle"
              [borderSettings]="button_13.borderSettings"
              [marginSettings]="button_13.marginSettings"
              [paddingSettings]="button_13.paddingSettings"
              [shadowSettings]="button_13.shadowSettings"
              [customColorSettings]="button_13.customColorSettings"
              [customSizeSettings]="button_13.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Dropdown Menu 14 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_14.icon"
              [placement]="dropdownMenu_14.placement"
              [triggerType]="dropdownMenu_14.triggerType"
              [items]="dropdownMenu_14.items"
              [label]="dropdownMenu_14.label"
              [labelMode]="dropdownMenu_14.labelMode"
            >
            </rappider-dropdown-menu>
          </div>

          <div class="rappider-component">
            <!-- Component: Dropdown Menu 15 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_15.icon"
              [placement]="dropdownMenu_15.placement"
              [triggerType]="dropdownMenu_15.triggerType"
              [items]="dropdownMenu_15.items"
              [label]="dropdownMenu_15.label"
              [labelMode]="dropdownMenu_15.labelMode"
            >
            </rappider-dropdown-menu>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 15 -->
    <div
      class="rappider-container container-15 col-12 container-spacing-settings mobile-navbar-bg mobile-navbar-settings"
    >
      <!-- Container: Container 16 -->
      <div
        class="rappider-container container-16 col-12 container-spacing-settings"
      >
        <div class="rappider-component">
          <!-- Component: Image 16 -->
          <rappider-image
            [source]="image_16.source"
            [alternateText]="image_16.alternateText"
            [placeholder]="image_16.placeholder"
            [disablePreview]="image_16.disablePreview"
            [borderSettings]="image_16.borderSettings"
            [shadowSettings]="image_16.shadowSettings"
            [paddingSettings]="image_16.paddingSettings"
            [marginSettings]="image_16.marginSettings"
            [customSizeSettings]="image_16.customSizeSettings"
          >
          </rappider-image>
        </div>

        <!-- Container: Container 17 -->
        <div
          class="rappider-container container-17 col-1 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Cart Preview  17 -->
            <rappider-cart-preview
              [cartItem]="cartPreview_17.cartItem"
              [footer]="cartPreview_17.footer"
              [footerContent]="cartPreview_17.footerContent"
              [buttons]="cartPreview_17.buttons"
              [dropdownButton]="cartPreview_17.dropdownButton"
              [placement]="cartPreview_17.placement"
              [triggerType]="cartPreview_17.triggerType"
            >
            </rappider-cart-preview>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 18 -->
            <rappider-icon
              [name]="icon_18.name"
              [color]="icon_18.color"
              [size]="icon_18.size"
              [type]="icon_18.type"
              [theme]="icon_18.theme"
              [animation]="icon_18.animation"
              [style]="icon_18.style"
              [secondColor]="icon_18.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>

      <!-- Container: Container 18 -->
      <div class="rappider-container container-18 col-12">
        <div class="rappider-component">
          <!-- Component: Input Group 19 -->
          <rappider-input-group
            [prefixIcon]="inputGroup_19.prefixIcon"
            [suffixIcon]="inputGroup_19.suffixIcon"
            [prefixButton]="inputGroup_19.prefixButton"
            [suffixButton]="inputGroup_19.suffixButton"
            [textbox]="inputGroup_19.textbox"
            [prefixText]="inputGroup_19.prefixText"
            [suffixText]="inputGroup_19.suffixText"
          >
          </rappider-input-group>
        </div>
      </div>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 19 -->
  <div class="rappider-container container-19 col-12">
    <!-- Container: Container 20 -->
    <div class="rappider-container container-20 col-12">
      <!-- Container: Container 21 -->
      <div class="rappider-container container-21 col-7">
        <div class="rappider-component">
          <!-- Component: Heading 20 -->
          <rappider-heading
            [content]="heading_20.content"
            [type]="heading_20.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Text 21 -->
          <rappider-text
            [textMode]="text_21.textMode"
            [text]="text_21.text"
            [content]="text_21.content"
            [typography]="text_21.typography"
            [colorSettings]="text_21.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 22 -->
      <div class="rappider-container container-22 col-5">
        <div class="rappider-component">
          <!-- Component: Textbox 22 -->
          <rappider-textbox
            [placeholder]="textbox_22.placeholder"
            [type]="textbox_22.type"
            [mask]="textbox_22.mask"
            [maskGuide]="textbox_22.maskGuide"
            [cssStyle]="textbox_22.cssStyle"
            [cssClass]="textbox_22.cssClass"
            [disabled]="textbox_22.disabled"
            [mentionSupported]="textbox_22.mentionSupported"
            [mentionPrefix]="textbox_22.mentionPrefix"
            [mentionValues]="textbox_22.mentionValues"
            [borderSettings]="textbox_22.borderSettings"
            [sizeSettings]="textbox_22.sizeSettings"
            [colorSettings]="textbox_22.colorSettings"
            [boxShadowSettings]="textbox_22.boxShadowSettings"
            [paddingSettings]="textbox_22.paddingSettings"
            [marginSettings]="textbox_22.marginSettings"
            [size]="textbox_22.size"
          >
          </rappider-textbox>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 23 -->
          <rappider-button
            [text]="button_23.text"
            [type]="button_23.type"
            [shape]="button_23.shape"
            [size]="button_23.size"
            [colorType]="button_23.colorType"
            [icon]="button_23.icon"
            [iconPlacement]="button_23.iconPlacement"
            [transparent]="button_23.transparent"
            [loading]="button_23.loading"
            [block]="button_23.block"
            [disabled]="button_23.disabled"
            [key]="button_23.key"
            [emitWithoutPopconfirm]="button_23.emitWithoutPopconfirm"
            [popconfirmTitle]="button_23.popconfirmTitle"
            [borderSettings]="button_23.borderSettings"
            [marginSettings]="button_23.marginSettings"
            [paddingSettings]="button_23.paddingSettings"
            [shadowSettings]="button_23.shadowSettings"
            [customColorSettings]="button_23.customColorSettings"
            [customSizeSettings]="button_23.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 23 -->
    <div class="rappider-container container-23 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 24 -->
        <rappider-divider
          [style]="divider_24.style"
          [type]="divider_24.type"
          [text]="divider_24.text"
          [textPlacement]="divider_24.textPlacement"
          [dividerWidth]="divider_24.dividerWidth"
          [dividerColor]="divider_24.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 24 -->
    <div class="rappider-container container-24 col-12">
      <!-- Container: Container 25 -->
      <div class="rappider-container container-25 col-5 footer-container-width">
        <!-- Container: Container 26 -->
        <div class="rappider-container container-26 col-12 p-0">
          <div class="rappider-component">
            <!-- Component: Heading 25 -->
            <rappider-heading
              [content]="heading_25.content"
              [type]="heading_25.type"
            >
            </rappider-heading>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 26 -->
            <rappider-text
              [textMode]="text_26.textMode"
              [text]="text_26.text"
              [content]="text_26.content"
              [typography]="text_26.typography"
              [colorSettings]="text_26.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 27 -->
            <rappider-text
              [textMode]="text_27.textMode"
              [text]="text_27.text"
              [content]="text_27.content"
              [typography]="text_27.typography"
              [colorSettings]="text_27.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 28 -->
            <rappider-text
              [textMode]="text_28.textMode"
              [text]="text_28.text"
              [content]="text_28.content"
              [typography]="text_28.typography"
              [colorSettings]="text_28.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 29 -->
            <rappider-text
              [textMode]="text_29.textMode"
              [text]="text_29.text"
              [content]="text_29.content"
              [typography]="text_29.typography"
              [colorSettings]="text_29.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 27 -->
        <div class="rappider-container container-27 col-12">
          <div class="rappider-component">
            <!-- Component: Icon 30 -->
            <rappider-icon
              [name]="icon_30.name"
              [color]="icon_30.color"
              [size]="icon_30.size"
              [type]="icon_30.type"
              [theme]="icon_30.theme"
              [animation]="icon_30.animation"
              [style]="icon_30.style"
              [secondColor]="icon_30.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 31 -->
            <rappider-icon
              [name]="icon_31.name"
              [color]="icon_31.color"
              [size]="icon_31.size"
              [type]="icon_31.type"
              [theme]="icon_31.theme"
              [animation]="icon_31.animation"
              [style]="icon_31.style"
              [secondColor]="icon_31.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 32 -->
            <rappider-icon
              [name]="icon_32.name"
              [color]="icon_32.color"
              [size]="icon_32.size"
              [type]="icon_32.type"
              [theme]="icon_32.theme"
              [animation]="icon_32.animation"
              [style]="icon_32.style"
              [secondColor]="icon_32.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 33 -->
            <rappider-icon
              [name]="icon_33.name"
              [color]="icon_33.color"
              [size]="icon_33.size"
              [type]="icon_33.type"
              [theme]="icon_33.theme"
              [animation]="icon_33.animation"
              [style]="icon_33.style"
              [secondColor]="icon_33.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>

      <!-- Container: Container 28 -->
      <div class="rappider-container container-28 col-2 footer-container-width">
        <div class="rappider-component">
          <!-- Component: Heading 34 -->
          <rappider-heading
            [content]="heading_34.content"
            [type]="heading_34.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 35 -->
          <rappider-button
            [text]="button_35.text"
            [type]="button_35.type"
            [shape]="button_35.shape"
            [size]="button_35.size"
            [colorType]="button_35.colorType"
            [icon]="button_35.icon"
            [iconPlacement]="button_35.iconPlacement"
            [transparent]="button_35.transparent"
            [loading]="button_35.loading"
            [block]="button_35.block"
            [disabled]="button_35.disabled"
            [key]="button_35.key"
            [emitWithoutPopconfirm]="button_35.emitWithoutPopconfirm"
            [popconfirmTitle]="button_35.popconfirmTitle"
            [borderSettings]="button_35.borderSettings"
            [marginSettings]="button_35.marginSettings"
            [paddingSettings]="button_35.paddingSettings"
            [shadowSettings]="button_35.shadowSettings"
            [customColorSettings]="button_35.customColorSettings"
            [customSizeSettings]="button_35.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 36 -->
          <rappider-button
            [text]="button_36.text"
            [type]="button_36.type"
            [shape]="button_36.shape"
            [size]="button_36.size"
            [colorType]="button_36.colorType"
            [icon]="button_36.icon"
            [iconPlacement]="button_36.iconPlacement"
            [transparent]="button_36.transparent"
            [loading]="button_36.loading"
            [block]="button_36.block"
            [disabled]="button_36.disabled"
            [key]="button_36.key"
            [emitWithoutPopconfirm]="button_36.emitWithoutPopconfirm"
            [popconfirmTitle]="button_36.popconfirmTitle"
            [borderSettings]="button_36.borderSettings"
            [marginSettings]="button_36.marginSettings"
            [paddingSettings]="button_36.paddingSettings"
            [shadowSettings]="button_36.shadowSettings"
            [customColorSettings]="button_36.customColorSettings"
            [customSizeSettings]="button_36.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 37 -->
          <rappider-button
            [text]="button_37.text"
            [type]="button_37.type"
            [shape]="button_37.shape"
            [size]="button_37.size"
            [colorType]="button_37.colorType"
            [icon]="button_37.icon"
            [iconPlacement]="button_37.iconPlacement"
            [transparent]="button_37.transparent"
            [loading]="button_37.loading"
            [block]="button_37.block"
            [disabled]="button_37.disabled"
            [key]="button_37.key"
            [emitWithoutPopconfirm]="button_37.emitWithoutPopconfirm"
            [popconfirmTitle]="button_37.popconfirmTitle"
            [borderSettings]="button_37.borderSettings"
            [marginSettings]="button_37.marginSettings"
            [paddingSettings]="button_37.paddingSettings"
            [shadowSettings]="button_37.shadowSettings"
            [customColorSettings]="button_37.customColorSettings"
            [customSizeSettings]="button_37.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 38 -->
          <rappider-button
            [text]="button_38.text"
            [type]="button_38.type"
            [shape]="button_38.shape"
            [size]="button_38.size"
            [colorType]="button_38.colorType"
            [icon]="button_38.icon"
            [iconPlacement]="button_38.iconPlacement"
            [transparent]="button_38.transparent"
            [loading]="button_38.loading"
            [block]="button_38.block"
            [disabled]="button_38.disabled"
            [key]="button_38.key"
            [emitWithoutPopconfirm]="button_38.emitWithoutPopconfirm"
            [popconfirmTitle]="button_38.popconfirmTitle"
            [borderSettings]="button_38.borderSettings"
            [marginSettings]="button_38.marginSettings"
            [paddingSettings]="button_38.paddingSettings"
            [shadowSettings]="button_38.shadowSettings"
            [customColorSettings]="button_38.customColorSettings"
            [customSizeSettings]="button_38.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 39 -->
          <rappider-button
            [text]="button_39.text"
            [type]="button_39.type"
            [shape]="button_39.shape"
            [size]="button_39.size"
            [colorType]="button_39.colorType"
            [icon]="button_39.icon"
            [iconPlacement]="button_39.iconPlacement"
            [transparent]="button_39.transparent"
            [loading]="button_39.loading"
            [block]="button_39.block"
            [disabled]="button_39.disabled"
            [key]="button_39.key"
            [emitWithoutPopconfirm]="button_39.emitWithoutPopconfirm"
            [popconfirmTitle]="button_39.popconfirmTitle"
            [borderSettings]="button_39.borderSettings"
            [marginSettings]="button_39.marginSettings"
            [paddingSettings]="button_39.paddingSettings"
            [shadowSettings]="button_39.shadowSettings"
            [customColorSettings]="button_39.customColorSettings"
            [customSizeSettings]="button_39.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 29 -->
      <div class="rappider-container container-29 col-2 footer-container-width">
        <div class="rappider-component">
          <!-- Component: Heading 40 -->
          <rappider-heading
            [content]="heading_40.content"
            [type]="heading_40.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 41 -->
          <rappider-button
            [text]="button_41.text"
            [type]="button_41.type"
            [shape]="button_41.shape"
            [size]="button_41.size"
            [colorType]="button_41.colorType"
            [icon]="button_41.icon"
            [iconPlacement]="button_41.iconPlacement"
            [transparent]="button_41.transparent"
            [loading]="button_41.loading"
            [block]="button_41.block"
            [disabled]="button_41.disabled"
            [key]="button_41.key"
            [emitWithoutPopconfirm]="button_41.emitWithoutPopconfirm"
            [popconfirmTitle]="button_41.popconfirmTitle"
            [borderSettings]="button_41.borderSettings"
            [marginSettings]="button_41.marginSettings"
            [paddingSettings]="button_41.paddingSettings"
            [shadowSettings]="button_41.shadowSettings"
            [customColorSettings]="button_41.customColorSettings"
            [customSizeSettings]="button_41.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 42 -->
          <rappider-button
            [text]="button_42.text"
            [type]="button_42.type"
            [shape]="button_42.shape"
            [size]="button_42.size"
            [colorType]="button_42.colorType"
            [icon]="button_42.icon"
            [iconPlacement]="button_42.iconPlacement"
            [transparent]="button_42.transparent"
            [loading]="button_42.loading"
            [block]="button_42.block"
            [disabled]="button_42.disabled"
            [key]="button_42.key"
            [emitWithoutPopconfirm]="button_42.emitWithoutPopconfirm"
            [popconfirmTitle]="button_42.popconfirmTitle"
            [borderSettings]="button_42.borderSettings"
            [marginSettings]="button_42.marginSettings"
            [paddingSettings]="button_42.paddingSettings"
            [shadowSettings]="button_42.shadowSettings"
            [customColorSettings]="button_42.customColorSettings"
            [customSizeSettings]="button_42.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 43 -->
          <rappider-button
            [text]="button_43.text"
            [type]="button_43.type"
            [shape]="button_43.shape"
            [size]="button_43.size"
            [colorType]="button_43.colorType"
            [icon]="button_43.icon"
            [iconPlacement]="button_43.iconPlacement"
            [transparent]="button_43.transparent"
            [loading]="button_43.loading"
            [block]="button_43.block"
            [disabled]="button_43.disabled"
            [key]="button_43.key"
            [emitWithoutPopconfirm]="button_43.emitWithoutPopconfirm"
            [popconfirmTitle]="button_43.popconfirmTitle"
            [borderSettings]="button_43.borderSettings"
            [marginSettings]="button_43.marginSettings"
            [paddingSettings]="button_43.paddingSettings"
            [shadowSettings]="button_43.shadowSettings"
            [customColorSettings]="button_43.customColorSettings"
            [customSizeSettings]="button_43.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 44 -->
          <rappider-button
            [text]="button_44.text"
            [type]="button_44.type"
            [shape]="button_44.shape"
            [size]="button_44.size"
            [colorType]="button_44.colorType"
            [icon]="button_44.icon"
            [iconPlacement]="button_44.iconPlacement"
            [transparent]="button_44.transparent"
            [loading]="button_44.loading"
            [block]="button_44.block"
            [disabled]="button_44.disabled"
            [key]="button_44.key"
            [emitWithoutPopconfirm]="button_44.emitWithoutPopconfirm"
            [popconfirmTitle]="button_44.popconfirmTitle"
            [borderSettings]="button_44.borderSettings"
            [marginSettings]="button_44.marginSettings"
            [paddingSettings]="button_44.paddingSettings"
            [shadowSettings]="button_44.shadowSettings"
            [customColorSettings]="button_44.customColorSettings"
            [customSizeSettings]="button_44.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 30 -->
      <div class="rappider-container container-30 col-2 footer-container-width">
        <div class="rappider-component">
          <!-- Component: Heading 45 -->
          <rappider-heading
            [content]="heading_45.content"
            [type]="heading_45.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 46 -->
          <rappider-button
            [text]="button_46.text"
            [type]="button_46.type"
            [shape]="button_46.shape"
            [size]="button_46.size"
            [colorType]="button_46.colorType"
            [icon]="button_46.icon"
            [iconPlacement]="button_46.iconPlacement"
            [transparent]="button_46.transparent"
            [loading]="button_46.loading"
            [block]="button_46.block"
            [disabled]="button_46.disabled"
            [key]="button_46.key"
            [emitWithoutPopconfirm]="button_46.emitWithoutPopconfirm"
            [popconfirmTitle]="button_46.popconfirmTitle"
            [borderSettings]="button_46.borderSettings"
            [marginSettings]="button_46.marginSettings"
            [paddingSettings]="button_46.paddingSettings"
            [shadowSettings]="button_46.shadowSettings"
            [customColorSettings]="button_46.customColorSettings"
            [customSizeSettings]="button_46.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 47 -->
          <rappider-button
            [text]="button_47.text"
            [type]="button_47.type"
            [shape]="button_47.shape"
            [size]="button_47.size"
            [colorType]="button_47.colorType"
            [icon]="button_47.icon"
            [iconPlacement]="button_47.iconPlacement"
            [transparent]="button_47.transparent"
            [loading]="button_47.loading"
            [block]="button_47.block"
            [disabled]="button_47.disabled"
            [key]="button_47.key"
            [emitWithoutPopconfirm]="button_47.emitWithoutPopconfirm"
            [popconfirmTitle]="button_47.popconfirmTitle"
            [borderSettings]="button_47.borderSettings"
            [marginSettings]="button_47.marginSettings"
            [paddingSettings]="button_47.paddingSettings"
            [shadowSettings]="button_47.shadowSettings"
            [customColorSettings]="button_47.customColorSettings"
            [customSizeSettings]="button_47.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 48 -->
          <rappider-button
            [text]="button_48.text"
            [type]="button_48.type"
            [shape]="button_48.shape"
            [size]="button_48.size"
            [colorType]="button_48.colorType"
            [icon]="button_48.icon"
            [iconPlacement]="button_48.iconPlacement"
            [transparent]="button_48.transparent"
            [loading]="button_48.loading"
            [block]="button_48.block"
            [disabled]="button_48.disabled"
            [key]="button_48.key"
            [emitWithoutPopconfirm]="button_48.emitWithoutPopconfirm"
            [popconfirmTitle]="button_48.popconfirmTitle"
            [borderSettings]="button_48.borderSettings"
            [marginSettings]="button_48.marginSettings"
            [paddingSettings]="button_48.paddingSettings"
            [shadowSettings]="button_48.shadowSettings"
            [customColorSettings]="button_48.customColorSettings"
            [customSizeSettings]="button_48.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 49 -->
          <rappider-button
            [text]="button_49.text"
            [type]="button_49.type"
            [shape]="button_49.shape"
            [size]="button_49.size"
            [colorType]="button_49.colorType"
            [icon]="button_49.icon"
            [iconPlacement]="button_49.iconPlacement"
            [transparent]="button_49.transparent"
            [loading]="button_49.loading"
            [block]="button_49.block"
            [disabled]="button_49.disabled"
            [key]="button_49.key"
            [emitWithoutPopconfirm]="button_49.emitWithoutPopconfirm"
            [popconfirmTitle]="button_49.popconfirmTitle"
            [borderSettings]="button_49.borderSettings"
            [marginSettings]="button_49.marginSettings"
            [paddingSettings]="button_49.paddingSettings"
            [shadowSettings]="button_49.shadowSettings"
            [customColorSettings]="button_49.customColorSettings"
            [customSizeSettings]="button_49.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 31 -->
    <div class="rappider-container container-31 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 50 -->
        <rappider-divider
          [style]="divider_50.style"
          [type]="divider_50.type"
          [text]="divider_50.text"
          [textPlacement]="divider_50.textPlacement"
          [dividerWidth]="divider_50.dividerWidth"
          [dividerColor]="divider_50.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 32 -->
    <div class="rappider-container container-32 col-12">
      <!-- Container: Container 33 -->
      <div
        class="rappider-container container-33 col-12 container-spacing-settings"
      >
        <!-- Container: Container 34 -->
        <div class="rappider-container container-34 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 51 -->
            <rappider-text
              [textMode]="text_51.textMode"
              [text]="text_51.text"
              [content]="text_51.content"
              [typography]="text_51.typography"
              [colorSettings]="text_51.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 35 -->
        <div
          class="rappider-container container-35 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 52 -->
            <rappider-button
              [text]="button_52.text"
              [type]="button_52.type"
              [shape]="button_52.shape"
              [size]="button_52.size"
              [colorType]="button_52.colorType"
              [icon]="button_52.icon"
              [iconPlacement]="button_52.iconPlacement"
              [transparent]="button_52.transparent"
              [loading]="button_52.loading"
              [block]="button_52.block"
              [disabled]="button_52.disabled"
              [key]="button_52.key"
              [emitWithoutPopconfirm]="button_52.emitWithoutPopconfirm"
              [popconfirmTitle]="button_52.popconfirmTitle"
              [borderSettings]="button_52.borderSettings"
              [marginSettings]="button_52.marginSettings"
              [paddingSettings]="button_52.paddingSettings"
              [shadowSettings]="button_52.shadowSettings"
              [customColorSettings]="button_52.customColorSettings"
              [customSizeSettings]="button_52.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 53 -->
            <rappider-button
              [text]="button_53.text"
              [type]="button_53.type"
              [shape]="button_53.shape"
              [size]="button_53.size"
              [colorType]="button_53.colorType"
              [icon]="button_53.icon"
              [iconPlacement]="button_53.iconPlacement"
              [transparent]="button_53.transparent"
              [loading]="button_53.loading"
              [block]="button_53.block"
              [disabled]="button_53.disabled"
              [key]="button_53.key"
              [emitWithoutPopconfirm]="button_53.emitWithoutPopconfirm"
              [popconfirmTitle]="button_53.popconfirmTitle"
              [borderSettings]="button_53.borderSettings"
              [marginSettings]="button_53.marginSettings"
              [paddingSettings]="button_53.paddingSettings"
              [shadowSettings]="button_53.shadowSettings"
              [customColorSettings]="button_53.customColorSettings"
              [customSizeSettings]="button_53.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 54 -->
            <rappider-button
              [text]="button_54.text"
              [type]="button_54.type"
              [shape]="button_54.shape"
              [size]="button_54.size"
              [colorType]="button_54.colorType"
              [icon]="button_54.icon"
              [iconPlacement]="button_54.iconPlacement"
              [transparent]="button_54.transparent"
              [loading]="button_54.loading"
              [block]="button_54.block"
              [disabled]="button_54.disabled"
              [key]="button_54.key"
              [emitWithoutPopconfirm]="button_54.emitWithoutPopconfirm"
              [popconfirmTitle]="button_54.popconfirmTitle"
              [borderSettings]="button_54.borderSettings"
              [marginSettings]="button_54.marginSettings"
              [paddingSettings]="button_54.paddingSettings"
              [shadowSettings]="button_54.shadowSettings"
              [customColorSettings]="button_54.customColorSettings"
              [customSizeSettings]="button_54.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 55 -->
            <rappider-button
              [text]="button_55.text"
              [type]="button_55.type"
              [shape]="button_55.shape"
              [size]="button_55.size"
              [colorType]="button_55.colorType"
              [icon]="button_55.icon"
              [iconPlacement]="button_55.iconPlacement"
              [transparent]="button_55.transparent"
              [loading]="button_55.loading"
              [block]="button_55.block"
              [disabled]="button_55.disabled"
              [key]="button_55.key"
              [emitWithoutPopconfirm]="button_55.emitWithoutPopconfirm"
              [popconfirmTitle]="button_55.popconfirmTitle"
              [borderSettings]="button_55.borderSettings"
              [marginSettings]="button_55.marginSettings"
              [paddingSettings]="button_55.paddingSettings"
              [shadowSettings]="button_55.shadowSettings"
              [customColorSettings]="button_55.customColorSettings"
              [customSizeSettings]="button_55.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 56 -->
            <rappider-button
              [text]="button_56.text"
              [type]="button_56.type"
              [shape]="button_56.shape"
              [size]="button_56.size"
              [colorType]="button_56.colorType"
              [icon]="button_56.icon"
              [iconPlacement]="button_56.iconPlacement"
              [transparent]="button_56.transparent"
              [loading]="button_56.loading"
              [block]="button_56.block"
              [disabled]="button_56.disabled"
              [key]="button_56.key"
              [emitWithoutPopconfirm]="button_56.emitWithoutPopconfirm"
              [popconfirmTitle]="button_56.popconfirmTitle"
              [borderSettings]="button_56.borderSettings"
              [marginSettings]="button_56.marginSettings"
              [paddingSettings]="button_56.paddingSettings"
              [shadowSettings]="button_56.shadowSettings"
              [customColorSettings]="button_56.customColorSettings"
              [customSizeSettings]="button_56.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 57 -->
            <rappider-button
              [text]="button_57.text"
              [type]="button_57.type"
              [shape]="button_57.shape"
              [size]="button_57.size"
              [colorType]="button_57.colorType"
              [icon]="button_57.icon"
              [iconPlacement]="button_57.iconPlacement"
              [transparent]="button_57.transparent"
              [loading]="button_57.loading"
              [block]="button_57.block"
              [disabled]="button_57.disabled"
              [key]="button_57.key"
              [emitWithoutPopconfirm]="button_57.emitWithoutPopconfirm"
              [popconfirmTitle]="button_57.popconfirmTitle"
              [borderSettings]="button_57.borderSettings"
              [marginSettings]="button_57.marginSettings"
              [paddingSettings]="button_57.paddingSettings"
              [shadowSettings]="button_57.shadowSettings"
              [customColorSettings]="button_57.customColorSettings"
              [customSizeSettings]="button_57.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 36 -->
      <div
        class="rappider-container container-36 col-12 container-spacing-settings"
      >
        <!-- Container: Container 37 -->
        <div class="rappider-container container-37 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 58 -->
            <rappider-text
              [textMode]="text_58.textMode"
              [text]="text_58.text"
              [content]="text_58.content"
              [typography]="text_58.typography"
              [colorSettings]="text_58.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 38 -->
        <div
          class="rappider-container container-38 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 59 -->
            <rappider-button
              [text]="button_59.text"
              [type]="button_59.type"
              [shape]="button_59.shape"
              [size]="button_59.size"
              [colorType]="button_59.colorType"
              [icon]="button_59.icon"
              [iconPlacement]="button_59.iconPlacement"
              [transparent]="button_59.transparent"
              [loading]="button_59.loading"
              [block]="button_59.block"
              [disabled]="button_59.disabled"
              [key]="button_59.key"
              [emitWithoutPopconfirm]="button_59.emitWithoutPopconfirm"
              [popconfirmTitle]="button_59.popconfirmTitle"
              [borderSettings]="button_59.borderSettings"
              [marginSettings]="button_59.marginSettings"
              [paddingSettings]="button_59.paddingSettings"
              [shadowSettings]="button_59.shadowSettings"
              [customColorSettings]="button_59.customColorSettings"
              [customSizeSettings]="button_59.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 60 -->
            <rappider-button
              [text]="button_60.text"
              [type]="button_60.type"
              [shape]="button_60.shape"
              [size]="button_60.size"
              [colorType]="button_60.colorType"
              [icon]="button_60.icon"
              [iconPlacement]="button_60.iconPlacement"
              [transparent]="button_60.transparent"
              [loading]="button_60.loading"
              [block]="button_60.block"
              [disabled]="button_60.disabled"
              [key]="button_60.key"
              [emitWithoutPopconfirm]="button_60.emitWithoutPopconfirm"
              [popconfirmTitle]="button_60.popconfirmTitle"
              [borderSettings]="button_60.borderSettings"
              [marginSettings]="button_60.marginSettings"
              [paddingSettings]="button_60.paddingSettings"
              [shadowSettings]="button_60.shadowSettings"
              [customColorSettings]="button_60.customColorSettings"
              [customSizeSettings]="button_60.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 61 -->
            <rappider-button
              [text]="button_61.text"
              [type]="button_61.type"
              [shape]="button_61.shape"
              [size]="button_61.size"
              [colorType]="button_61.colorType"
              [icon]="button_61.icon"
              [iconPlacement]="button_61.iconPlacement"
              [transparent]="button_61.transparent"
              [loading]="button_61.loading"
              [block]="button_61.block"
              [disabled]="button_61.disabled"
              [key]="button_61.key"
              [emitWithoutPopconfirm]="button_61.emitWithoutPopconfirm"
              [popconfirmTitle]="button_61.popconfirmTitle"
              [borderSettings]="button_61.borderSettings"
              [marginSettings]="button_61.marginSettings"
              [paddingSettings]="button_61.paddingSettings"
              [shadowSettings]="button_61.shadowSettings"
              [customColorSettings]="button_61.customColorSettings"
              [customSizeSettings]="button_61.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 62 -->
            <rappider-button
              [text]="button_62.text"
              [type]="button_62.type"
              [shape]="button_62.shape"
              [size]="button_62.size"
              [colorType]="button_62.colorType"
              [icon]="button_62.icon"
              [iconPlacement]="button_62.iconPlacement"
              [transparent]="button_62.transparent"
              [loading]="button_62.loading"
              [block]="button_62.block"
              [disabled]="button_62.disabled"
              [key]="button_62.key"
              [emitWithoutPopconfirm]="button_62.emitWithoutPopconfirm"
              [popconfirmTitle]="button_62.popconfirmTitle"
              [borderSettings]="button_62.borderSettings"
              [marginSettings]="button_62.marginSettings"
              [paddingSettings]="button_62.paddingSettings"
              [shadowSettings]="button_62.shadowSettings"
              [customColorSettings]="button_62.customColorSettings"
              [customSizeSettings]="button_62.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 63 -->
            <rappider-button
              [text]="button_63.text"
              [type]="button_63.type"
              [shape]="button_63.shape"
              [size]="button_63.size"
              [colorType]="button_63.colorType"
              [icon]="button_63.icon"
              [iconPlacement]="button_63.iconPlacement"
              [transparent]="button_63.transparent"
              [loading]="button_63.loading"
              [block]="button_63.block"
              [disabled]="button_63.disabled"
              [key]="button_63.key"
              [emitWithoutPopconfirm]="button_63.emitWithoutPopconfirm"
              [popconfirmTitle]="button_63.popconfirmTitle"
              [borderSettings]="button_63.borderSettings"
              [marginSettings]="button_63.marginSettings"
              [paddingSettings]="button_63.paddingSettings"
              [shadowSettings]="button_63.shadowSettings"
              [customColorSettings]="button_63.customColorSettings"
              [customSizeSettings]="button_63.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 64 -->
            <rappider-button
              [text]="button_64.text"
              [type]="button_64.type"
              [shape]="button_64.shape"
              [size]="button_64.size"
              [colorType]="button_64.colorType"
              [icon]="button_64.icon"
              [iconPlacement]="button_64.iconPlacement"
              [transparent]="button_64.transparent"
              [loading]="button_64.loading"
              [block]="button_64.block"
              [disabled]="button_64.disabled"
              [key]="button_64.key"
              [emitWithoutPopconfirm]="button_64.emitWithoutPopconfirm"
              [popconfirmTitle]="button_64.popconfirmTitle"
              [borderSettings]="button_64.borderSettings"
              [marginSettings]="button_64.marginSettings"
              [paddingSettings]="button_64.paddingSettings"
              [shadowSettings]="button_64.shadowSettings"
              [customColorSettings]="button_64.customColorSettings"
              [customSizeSettings]="button_64.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 65 -->
            <rappider-button
              [text]="button_65.text"
              [type]="button_65.type"
              [shape]="button_65.shape"
              [size]="button_65.size"
              [colorType]="button_65.colorType"
              [icon]="button_65.icon"
              [iconPlacement]="button_65.iconPlacement"
              [transparent]="button_65.transparent"
              [loading]="button_65.loading"
              [block]="button_65.block"
              [disabled]="button_65.disabled"
              [key]="button_65.key"
              [emitWithoutPopconfirm]="button_65.emitWithoutPopconfirm"
              [popconfirmTitle]="button_65.popconfirmTitle"
              [borderSettings]="button_65.borderSettings"
              [marginSettings]="button_65.marginSettings"
              [paddingSettings]="button_65.paddingSettings"
              [shadowSettings]="button_65.shadowSettings"
              [customColorSettings]="button_65.customColorSettings"
              [customSizeSettings]="button_65.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 39 -->
      <div
        class="rappider-container container-39 col-12 container-spacing-settings"
      >
        <!-- Container: Container 40 -->
        <div class="rappider-container container-40 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 66 -->
            <rappider-text
              [textMode]="text_66.textMode"
              [text]="text_66.text"
              [content]="text_66.content"
              [typography]="text_66.typography"
              [colorSettings]="text_66.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 41 -->
        <div
          class="rappider-container container-41 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 67 -->
            <rappider-button
              [text]="button_67.text"
              [type]="button_67.type"
              [shape]="button_67.shape"
              [size]="button_67.size"
              [colorType]="button_67.colorType"
              [icon]="button_67.icon"
              [iconPlacement]="button_67.iconPlacement"
              [transparent]="button_67.transparent"
              [loading]="button_67.loading"
              [block]="button_67.block"
              [disabled]="button_67.disabled"
              [key]="button_67.key"
              [emitWithoutPopconfirm]="button_67.emitWithoutPopconfirm"
              [popconfirmTitle]="button_67.popconfirmTitle"
              [borderSettings]="button_67.borderSettings"
              [marginSettings]="button_67.marginSettings"
              [paddingSettings]="button_67.paddingSettings"
              [shadowSettings]="button_67.shadowSettings"
              [customColorSettings]="button_67.customColorSettings"
              [customSizeSettings]="button_67.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 68 -->
            <rappider-button
              [text]="button_68.text"
              [type]="button_68.type"
              [shape]="button_68.shape"
              [size]="button_68.size"
              [colorType]="button_68.colorType"
              [icon]="button_68.icon"
              [iconPlacement]="button_68.iconPlacement"
              [transparent]="button_68.transparent"
              [loading]="button_68.loading"
              [block]="button_68.block"
              [disabled]="button_68.disabled"
              [key]="button_68.key"
              [emitWithoutPopconfirm]="button_68.emitWithoutPopconfirm"
              [popconfirmTitle]="button_68.popconfirmTitle"
              [borderSettings]="button_68.borderSettings"
              [marginSettings]="button_68.marginSettings"
              [paddingSettings]="button_68.paddingSettings"
              [shadowSettings]="button_68.shadowSettings"
              [customColorSettings]="button_68.customColorSettings"
              [customSizeSettings]="button_68.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 69 -->
            <rappider-button
              [text]="button_69.text"
              [type]="button_69.type"
              [shape]="button_69.shape"
              [size]="button_69.size"
              [colorType]="button_69.colorType"
              [icon]="button_69.icon"
              [iconPlacement]="button_69.iconPlacement"
              [transparent]="button_69.transparent"
              [loading]="button_69.loading"
              [block]="button_69.block"
              [disabled]="button_69.disabled"
              [key]="button_69.key"
              [emitWithoutPopconfirm]="button_69.emitWithoutPopconfirm"
              [popconfirmTitle]="button_69.popconfirmTitle"
              [borderSettings]="button_69.borderSettings"
              [marginSettings]="button_69.marginSettings"
              [paddingSettings]="button_69.paddingSettings"
              [shadowSettings]="button_69.shadowSettings"
              [customColorSettings]="button_69.customColorSettings"
              [customSizeSettings]="button_69.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 70 -->
            <rappider-button
              [text]="button_70.text"
              [type]="button_70.type"
              [shape]="button_70.shape"
              [size]="button_70.size"
              [colorType]="button_70.colorType"
              [icon]="button_70.icon"
              [iconPlacement]="button_70.iconPlacement"
              [transparent]="button_70.transparent"
              [loading]="button_70.loading"
              [block]="button_70.block"
              [disabled]="button_70.disabled"
              [key]="button_70.key"
              [emitWithoutPopconfirm]="button_70.emitWithoutPopconfirm"
              [popconfirmTitle]="button_70.popconfirmTitle"
              [borderSettings]="button_70.borderSettings"
              [marginSettings]="button_70.marginSettings"
              [paddingSettings]="button_70.paddingSettings"
              [shadowSettings]="button_70.shadowSettings"
              [customColorSettings]="button_70.customColorSettings"
              [customSizeSettings]="button_70.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 71 -->
            <rappider-button
              [text]="button_71.text"
              [type]="button_71.type"
              [shape]="button_71.shape"
              [size]="button_71.size"
              [colorType]="button_71.colorType"
              [icon]="button_71.icon"
              [iconPlacement]="button_71.iconPlacement"
              [transparent]="button_71.transparent"
              [loading]="button_71.loading"
              [block]="button_71.block"
              [disabled]="button_71.disabled"
              [key]="button_71.key"
              [emitWithoutPopconfirm]="button_71.emitWithoutPopconfirm"
              [popconfirmTitle]="button_71.popconfirmTitle"
              [borderSettings]="button_71.borderSettings"
              [marginSettings]="button_71.marginSettings"
              [paddingSettings]="button_71.paddingSettings"
              [shadowSettings]="button_71.shadowSettings"
              [customColorSettings]="button_71.customColorSettings"
              [customSizeSettings]="button_71.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 72 -->
            <rappider-button
              [text]="button_72.text"
              [type]="button_72.type"
              [shape]="button_72.shape"
              [size]="button_72.size"
              [colorType]="button_72.colorType"
              [icon]="button_72.icon"
              [iconPlacement]="button_72.iconPlacement"
              [transparent]="button_72.transparent"
              [loading]="button_72.loading"
              [block]="button_72.block"
              [disabled]="button_72.disabled"
              [key]="button_72.key"
              [emitWithoutPopconfirm]="button_72.emitWithoutPopconfirm"
              [popconfirmTitle]="button_72.popconfirmTitle"
              [borderSettings]="button_72.borderSettings"
              [marginSettings]="button_72.marginSettings"
              [paddingSettings]="button_72.paddingSettings"
              [shadowSettings]="button_72.shadowSettings"
              [customColorSettings]="button_72.customColorSettings"
              [customSizeSettings]="button_72.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 73 -->
            <rappider-button
              [text]="button_73.text"
              [type]="button_73.type"
              [shape]="button_73.shape"
              [size]="button_73.size"
              [colorType]="button_73.colorType"
              [icon]="button_73.icon"
              [iconPlacement]="button_73.iconPlacement"
              [transparent]="button_73.transparent"
              [loading]="button_73.loading"
              [block]="button_73.block"
              [disabled]="button_73.disabled"
              [key]="button_73.key"
              [emitWithoutPopconfirm]="button_73.emitWithoutPopconfirm"
              [popconfirmTitle]="button_73.popconfirmTitle"
              [borderSettings]="button_73.borderSettings"
              [marginSettings]="button_73.marginSettings"
              [paddingSettings]="button_73.paddingSettings"
              [shadowSettings]="button_73.shadowSettings"
              [customColorSettings]="button_73.customColorSettings"
              [customSizeSettings]="button_73.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 42 -->
      <div
        class="rappider-container container-42 col-12 container-spacing-settings"
      >
        <!-- Container: Container 43 -->
        <div class="rappider-container container-43 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 74 -->
            <rappider-text
              [textMode]="text_74.textMode"
              [text]="text_74.text"
              [content]="text_74.content"
              [typography]="text_74.typography"
              [colorSettings]="text_74.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 44 -->
        <div
          class="rappider-container container-44 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 75 -->
            <rappider-button
              [text]="button_75.text"
              [type]="button_75.type"
              [shape]="button_75.shape"
              [size]="button_75.size"
              [colorType]="button_75.colorType"
              [icon]="button_75.icon"
              [iconPlacement]="button_75.iconPlacement"
              [transparent]="button_75.transparent"
              [loading]="button_75.loading"
              [block]="button_75.block"
              [disabled]="button_75.disabled"
              [key]="button_75.key"
              [emitWithoutPopconfirm]="button_75.emitWithoutPopconfirm"
              [popconfirmTitle]="button_75.popconfirmTitle"
              [borderSettings]="button_75.borderSettings"
              [marginSettings]="button_75.marginSettings"
              [paddingSettings]="button_75.paddingSettings"
              [shadowSettings]="button_75.shadowSettings"
              [customColorSettings]="button_75.customColorSettings"
              [customSizeSettings]="button_75.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 76 -->
            <rappider-button
              [text]="button_76.text"
              [type]="button_76.type"
              [shape]="button_76.shape"
              [size]="button_76.size"
              [colorType]="button_76.colorType"
              [icon]="button_76.icon"
              [iconPlacement]="button_76.iconPlacement"
              [transparent]="button_76.transparent"
              [loading]="button_76.loading"
              [block]="button_76.block"
              [disabled]="button_76.disabled"
              [key]="button_76.key"
              [emitWithoutPopconfirm]="button_76.emitWithoutPopconfirm"
              [popconfirmTitle]="button_76.popconfirmTitle"
              [borderSettings]="button_76.borderSettings"
              [marginSettings]="button_76.marginSettings"
              [paddingSettings]="button_76.paddingSettings"
              [shadowSettings]="button_76.shadowSettings"
              [customColorSettings]="button_76.customColorSettings"
              [customSizeSettings]="button_76.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 77 -->
            <rappider-button
              [text]="button_77.text"
              [type]="button_77.type"
              [shape]="button_77.shape"
              [size]="button_77.size"
              [colorType]="button_77.colorType"
              [icon]="button_77.icon"
              [iconPlacement]="button_77.iconPlacement"
              [transparent]="button_77.transparent"
              [loading]="button_77.loading"
              [block]="button_77.block"
              [disabled]="button_77.disabled"
              [key]="button_77.key"
              [emitWithoutPopconfirm]="button_77.emitWithoutPopconfirm"
              [popconfirmTitle]="button_77.popconfirmTitle"
              [borderSettings]="button_77.borderSettings"
              [marginSettings]="button_77.marginSettings"
              [paddingSettings]="button_77.paddingSettings"
              [shadowSettings]="button_77.shadowSettings"
              [customColorSettings]="button_77.customColorSettings"
              [customSizeSettings]="button_77.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 78 -->
            <rappider-button
              [text]="button_78.text"
              [type]="button_78.type"
              [shape]="button_78.shape"
              [size]="button_78.size"
              [colorType]="button_78.colorType"
              [icon]="button_78.icon"
              [iconPlacement]="button_78.iconPlacement"
              [transparent]="button_78.transparent"
              [loading]="button_78.loading"
              [block]="button_78.block"
              [disabled]="button_78.disabled"
              [key]="button_78.key"
              [emitWithoutPopconfirm]="button_78.emitWithoutPopconfirm"
              [popconfirmTitle]="button_78.popconfirmTitle"
              [borderSettings]="button_78.borderSettings"
              [marginSettings]="button_78.marginSettings"
              [paddingSettings]="button_78.paddingSettings"
              [shadowSettings]="button_78.shadowSettings"
              [customColorSettings]="button_78.customColorSettings"
              [customSizeSettings]="button_78.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 79 -->
            <rappider-button
              [text]="button_79.text"
              [type]="button_79.type"
              [shape]="button_79.shape"
              [size]="button_79.size"
              [colorType]="button_79.colorType"
              [icon]="button_79.icon"
              [iconPlacement]="button_79.iconPlacement"
              [transparent]="button_79.transparent"
              [loading]="button_79.loading"
              [block]="button_79.block"
              [disabled]="button_79.disabled"
              [key]="button_79.key"
              [emitWithoutPopconfirm]="button_79.emitWithoutPopconfirm"
              [popconfirmTitle]="button_79.popconfirmTitle"
              [borderSettings]="button_79.borderSettings"
              [marginSettings]="button_79.marginSettings"
              [paddingSettings]="button_79.paddingSettings"
              [shadowSettings]="button_79.shadowSettings"
              [customColorSettings]="button_79.customColorSettings"
              [customSizeSettings]="button_79.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 80 -->
            <rappider-button
              [text]="button_80.text"
              [type]="button_80.type"
              [shape]="button_80.shape"
              [size]="button_80.size"
              [colorType]="button_80.colorType"
              [icon]="button_80.icon"
              [iconPlacement]="button_80.iconPlacement"
              [transparent]="button_80.transparent"
              [loading]="button_80.loading"
              [block]="button_80.block"
              [disabled]="button_80.disabled"
              [key]="button_80.key"
              [emitWithoutPopconfirm]="button_80.emitWithoutPopconfirm"
              [popconfirmTitle]="button_80.popconfirmTitle"
              [borderSettings]="button_80.borderSettings"
              [marginSettings]="button_80.marginSettings"
              [paddingSettings]="button_80.paddingSettings"
              [shadowSettings]="button_80.shadowSettings"
              [customColorSettings]="button_80.customColorSettings"
              [customSizeSettings]="button_80.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 81 -->
            <rappider-button
              [text]="button_81.text"
              [type]="button_81.type"
              [shape]="button_81.shape"
              [size]="button_81.size"
              [colorType]="button_81.colorType"
              [icon]="button_81.icon"
              [iconPlacement]="button_81.iconPlacement"
              [transparent]="button_81.transparent"
              [loading]="button_81.loading"
              [block]="button_81.block"
              [disabled]="button_81.disabled"
              [key]="button_81.key"
              [emitWithoutPopconfirm]="button_81.emitWithoutPopconfirm"
              [popconfirmTitle]="button_81.popconfirmTitle"
              [borderSettings]="button_81.borderSettings"
              [marginSettings]="button_81.marginSettings"
              [paddingSettings]="button_81.paddingSettings"
              [shadowSettings]="button_81.shadowSettings"
              [customColorSettings]="button_81.customColorSettings"
              [customSizeSettings]="button_81.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 82 -->
            <rappider-button
              [text]="button_82.text"
              [type]="button_82.type"
              [shape]="button_82.shape"
              [size]="button_82.size"
              [colorType]="button_82.colorType"
              [icon]="button_82.icon"
              [iconPlacement]="button_82.iconPlacement"
              [transparent]="button_82.transparent"
              [loading]="button_82.loading"
              [block]="button_82.block"
              [disabled]="button_82.disabled"
              [key]="button_82.key"
              [emitWithoutPopconfirm]="button_82.emitWithoutPopconfirm"
              [popconfirmTitle]="button_82.popconfirmTitle"
              [borderSettings]="button_82.borderSettings"
              [marginSettings]="button_82.marginSettings"
              [paddingSettings]="button_82.paddingSettings"
              [shadowSettings]="button_82.shadowSettings"
              [customColorSettings]="button_82.customColorSettings"
              [customSizeSettings]="button_82.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 45 -->
      <div
        class="rappider-container container-45 col-12 container-spacing-settings"
      >
        <!-- Container: Container 46 -->
        <div class="rappider-container container-46 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 83 -->
            <rappider-text
              [textMode]="text_83.textMode"
              [text]="text_83.text"
              [content]="text_83.content"
              [typography]="text_83.typography"
              [colorSettings]="text_83.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 47 -->
        <div
          class="rappider-container container-47 col-6 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 84 -->
            <rappider-button
              [text]="button_84.text"
              [type]="button_84.type"
              [shape]="button_84.shape"
              [size]="button_84.size"
              [colorType]="button_84.colorType"
              [icon]="button_84.icon"
              [iconPlacement]="button_84.iconPlacement"
              [transparent]="button_84.transparent"
              [loading]="button_84.loading"
              [block]="button_84.block"
              [disabled]="button_84.disabled"
              [key]="button_84.key"
              [emitWithoutPopconfirm]="button_84.emitWithoutPopconfirm"
              [popconfirmTitle]="button_84.popconfirmTitle"
              [borderSettings]="button_84.borderSettings"
              [marginSettings]="button_84.marginSettings"
              [paddingSettings]="button_84.paddingSettings"
              [shadowSettings]="button_84.shadowSettings"
              [customColorSettings]="button_84.customColorSettings"
              [customSizeSettings]="button_84.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 85 -->
            <rappider-button
              [text]="button_85.text"
              [type]="button_85.type"
              [shape]="button_85.shape"
              [size]="button_85.size"
              [colorType]="button_85.colorType"
              [icon]="button_85.icon"
              [iconPlacement]="button_85.iconPlacement"
              [transparent]="button_85.transparent"
              [loading]="button_85.loading"
              [block]="button_85.block"
              [disabled]="button_85.disabled"
              [key]="button_85.key"
              [emitWithoutPopconfirm]="button_85.emitWithoutPopconfirm"
              [popconfirmTitle]="button_85.popconfirmTitle"
              [borderSettings]="button_85.borderSettings"
              [marginSettings]="button_85.marginSettings"
              [paddingSettings]="button_85.paddingSettings"
              [shadowSettings]="button_85.shadowSettings"
              [customColorSettings]="button_85.customColorSettings"
              [customSizeSettings]="button_85.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 86 -->
            <rappider-button
              [text]="button_86.text"
              [type]="button_86.type"
              [shape]="button_86.shape"
              [size]="button_86.size"
              [colorType]="button_86.colorType"
              [icon]="button_86.icon"
              [iconPlacement]="button_86.iconPlacement"
              [transparent]="button_86.transparent"
              [loading]="button_86.loading"
              [block]="button_86.block"
              [disabled]="button_86.disabled"
              [key]="button_86.key"
              [emitWithoutPopconfirm]="button_86.emitWithoutPopconfirm"
              [popconfirmTitle]="button_86.popconfirmTitle"
              [borderSettings]="button_86.borderSettings"
              [marginSettings]="button_86.marginSettings"
              [paddingSettings]="button_86.paddingSettings"
              [shadowSettings]="button_86.shadowSettings"
              [customColorSettings]="button_86.customColorSettings"
              [customSizeSettings]="button_86.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 87 -->
            <rappider-button
              [text]="button_87.text"
              [type]="button_87.type"
              [shape]="button_87.shape"
              [size]="button_87.size"
              [colorType]="button_87.colorType"
              [icon]="button_87.icon"
              [iconPlacement]="button_87.iconPlacement"
              [transparent]="button_87.transparent"
              [loading]="button_87.loading"
              [block]="button_87.block"
              [disabled]="button_87.disabled"
              [key]="button_87.key"
              [emitWithoutPopconfirm]="button_87.emitWithoutPopconfirm"
              [popconfirmTitle]="button_87.popconfirmTitle"
              [borderSettings]="button_87.borderSettings"
              [marginSettings]="button_87.marginSettings"
              [paddingSettings]="button_87.paddingSettings"
              [shadowSettings]="button_87.shadowSettings"
              [customColorSettings]="button_87.customColorSettings"
              [customSizeSettings]="button_87.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 88 -->
            <rappider-button
              [text]="button_88.text"
              [type]="button_88.type"
              [shape]="button_88.shape"
              [size]="button_88.size"
              [colorType]="button_88.colorType"
              [icon]="button_88.icon"
              [iconPlacement]="button_88.iconPlacement"
              [transparent]="button_88.transparent"
              [loading]="button_88.loading"
              [block]="button_88.block"
              [disabled]="button_88.disabled"
              [key]="button_88.key"
              [emitWithoutPopconfirm]="button_88.emitWithoutPopconfirm"
              [popconfirmTitle]="button_88.popconfirmTitle"
              [borderSettings]="button_88.borderSettings"
              [marginSettings]="button_88.marginSettings"
              [paddingSettings]="button_88.paddingSettings"
              [shadowSettings]="button_88.shadowSettings"
              [customColorSettings]="button_88.customColorSettings"
              [customSizeSettings]="button_88.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 89 -->
            <rappider-button
              [text]="button_89.text"
              [type]="button_89.type"
              [shape]="button_89.shape"
              [size]="button_89.size"
              [colorType]="button_89.colorType"
              [icon]="button_89.icon"
              [iconPlacement]="button_89.iconPlacement"
              [transparent]="button_89.transparent"
              [loading]="button_89.loading"
              [block]="button_89.block"
              [disabled]="button_89.disabled"
              [key]="button_89.key"
              [emitWithoutPopconfirm]="button_89.emitWithoutPopconfirm"
              [popconfirmTitle]="button_89.popconfirmTitle"
              [borderSettings]="button_89.borderSettings"
              [marginSettings]="button_89.marginSettings"
              [paddingSettings]="button_89.paddingSettings"
              [shadowSettings]="button_89.shadowSettings"
              [customColorSettings]="button_89.customColorSettings"
              [customSizeSettings]="button_89.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 48 -->
      <div
        class="rappider-container container-48 col-12 container-spacing-settings"
      >
        <!-- Container: Container 49 -->
        <div class="rappider-container container-49 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 90 -->
            <rappider-text
              [textMode]="text_90.textMode"
              [text]="text_90.text"
              [content]="text_90.content"
              [typography]="text_90.typography"
              [colorSettings]="text_90.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 50 -->
        <div
          class="rappider-container container-50 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 91 -->
            <rappider-button
              [text]="button_91.text"
              [type]="button_91.type"
              [shape]="button_91.shape"
              [size]="button_91.size"
              [colorType]="button_91.colorType"
              [icon]="button_91.icon"
              [iconPlacement]="button_91.iconPlacement"
              [transparent]="button_91.transparent"
              [loading]="button_91.loading"
              [block]="button_91.block"
              [disabled]="button_91.disabled"
              [key]="button_91.key"
              [emitWithoutPopconfirm]="button_91.emitWithoutPopconfirm"
              [popconfirmTitle]="button_91.popconfirmTitle"
              [borderSettings]="button_91.borderSettings"
              [marginSettings]="button_91.marginSettings"
              [paddingSettings]="button_91.paddingSettings"
              [shadowSettings]="button_91.shadowSettings"
              [customColorSettings]="button_91.customColorSettings"
              [customSizeSettings]="button_91.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 92 -->
            <rappider-button
              [text]="button_92.text"
              [type]="button_92.type"
              [shape]="button_92.shape"
              [size]="button_92.size"
              [colorType]="button_92.colorType"
              [icon]="button_92.icon"
              [iconPlacement]="button_92.iconPlacement"
              [transparent]="button_92.transparent"
              [loading]="button_92.loading"
              [block]="button_92.block"
              [disabled]="button_92.disabled"
              [key]="button_92.key"
              [emitWithoutPopconfirm]="button_92.emitWithoutPopconfirm"
              [popconfirmTitle]="button_92.popconfirmTitle"
              [borderSettings]="button_92.borderSettings"
              [marginSettings]="button_92.marginSettings"
              [paddingSettings]="button_92.paddingSettings"
              [shadowSettings]="button_92.shadowSettings"
              [customColorSettings]="button_92.customColorSettings"
              [customSizeSettings]="button_92.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 93 -->
            <rappider-button
              [text]="button_93.text"
              [type]="button_93.type"
              [shape]="button_93.shape"
              [size]="button_93.size"
              [colorType]="button_93.colorType"
              [icon]="button_93.icon"
              [iconPlacement]="button_93.iconPlacement"
              [transparent]="button_93.transparent"
              [loading]="button_93.loading"
              [block]="button_93.block"
              [disabled]="button_93.disabled"
              [key]="button_93.key"
              [emitWithoutPopconfirm]="button_93.emitWithoutPopconfirm"
              [popconfirmTitle]="button_93.popconfirmTitle"
              [borderSettings]="button_93.borderSettings"
              [marginSettings]="button_93.marginSettings"
              [paddingSettings]="button_93.paddingSettings"
              [shadowSettings]="button_93.shadowSettings"
              [customColorSettings]="button_93.customColorSettings"
              [customSizeSettings]="button_93.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 94 -->
            <rappider-button
              [text]="button_94.text"
              [type]="button_94.type"
              [shape]="button_94.shape"
              [size]="button_94.size"
              [colorType]="button_94.colorType"
              [icon]="button_94.icon"
              [iconPlacement]="button_94.iconPlacement"
              [transparent]="button_94.transparent"
              [loading]="button_94.loading"
              [block]="button_94.block"
              [disabled]="button_94.disabled"
              [key]="button_94.key"
              [emitWithoutPopconfirm]="button_94.emitWithoutPopconfirm"
              [popconfirmTitle]="button_94.popconfirmTitle"
              [borderSettings]="button_94.borderSettings"
              [marginSettings]="button_94.marginSettings"
              [paddingSettings]="button_94.paddingSettings"
              [shadowSettings]="button_94.shadowSettings"
              [customColorSettings]="button_94.customColorSettings"
              [customSizeSettings]="button_94.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 95 -->
            <rappider-button
              [text]="button_95.text"
              [type]="button_95.type"
              [shape]="button_95.shape"
              [size]="button_95.size"
              [colorType]="button_95.colorType"
              [icon]="button_95.icon"
              [iconPlacement]="button_95.iconPlacement"
              [transparent]="button_95.transparent"
              [loading]="button_95.loading"
              [block]="button_95.block"
              [disabled]="button_95.disabled"
              [key]="button_95.key"
              [emitWithoutPopconfirm]="button_95.emitWithoutPopconfirm"
              [popconfirmTitle]="button_95.popconfirmTitle"
              [borderSettings]="button_95.borderSettings"
              [marginSettings]="button_95.marginSettings"
              [paddingSettings]="button_95.paddingSettings"
              [shadowSettings]="button_95.shadowSettings"
              [customColorSettings]="button_95.customColorSettings"
              [customSizeSettings]="button_95.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 96 -->
            <rappider-button
              [text]="button_96.text"
              [type]="button_96.type"
              [shape]="button_96.shape"
              [size]="button_96.size"
              [colorType]="button_96.colorType"
              [icon]="button_96.icon"
              [iconPlacement]="button_96.iconPlacement"
              [transparent]="button_96.transparent"
              [loading]="button_96.loading"
              [block]="button_96.block"
              [disabled]="button_96.disabled"
              [key]="button_96.key"
              [emitWithoutPopconfirm]="button_96.emitWithoutPopconfirm"
              [popconfirmTitle]="button_96.popconfirmTitle"
              [borderSettings]="button_96.borderSettings"
              [marginSettings]="button_96.marginSettings"
              [paddingSettings]="button_96.paddingSettings"
              [shadowSettings]="button_96.shadowSettings"
              [customColorSettings]="button_96.customColorSettings"
              [customSizeSettings]="button_96.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 97 -->
            <rappider-button
              [text]="button_97.text"
              [type]="button_97.type"
              [shape]="button_97.shape"
              [size]="button_97.size"
              [colorType]="button_97.colorType"
              [icon]="button_97.icon"
              [iconPlacement]="button_97.iconPlacement"
              [transparent]="button_97.transparent"
              [loading]="button_97.loading"
              [block]="button_97.block"
              [disabled]="button_97.disabled"
              [key]="button_97.key"
              [emitWithoutPopconfirm]="button_97.emitWithoutPopconfirm"
              [popconfirmTitle]="button_97.popconfirmTitle"
              [borderSettings]="button_97.borderSettings"
              [marginSettings]="button_97.marginSettings"
              [paddingSettings]="button_97.paddingSettings"
              [shadowSettings]="button_97.shadowSettings"
              [customColorSettings]="button_97.customColorSettings"
              [customSizeSettings]="button_97.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 98 -->
            <rappider-button
              [text]="button_98.text"
              [type]="button_98.type"
              [shape]="button_98.shape"
              [size]="button_98.size"
              [colorType]="button_98.colorType"
              [icon]="button_98.icon"
              [iconPlacement]="button_98.iconPlacement"
              [transparent]="button_98.transparent"
              [loading]="button_98.loading"
              [block]="button_98.block"
              [disabled]="button_98.disabled"
              [key]="button_98.key"
              [emitWithoutPopconfirm]="button_98.emitWithoutPopconfirm"
              [popconfirmTitle]="button_98.popconfirmTitle"
              [borderSettings]="button_98.borderSettings"
              [marginSettings]="button_98.marginSettings"
              [paddingSettings]="button_98.paddingSettings"
              [shadowSettings]="button_98.shadowSettings"
              [customColorSettings]="button_98.customColorSettings"
              [customSizeSettings]="button_98.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 51 -->
    <div class="rappider-container container-51 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 99 -->
        <rappider-divider
          [style]="divider_99.style"
          [type]="divider_99.type"
          [text]="divider_99.text"
          [textPlacement]="divider_99.textPlacement"
          [dividerWidth]="divider_99.dividerWidth"
          [dividerColor]="divider_99.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 52 -->
    <div class="rappider-container container-52 col-12">
      <!-- Container: Container 53 -->
      <div class="rappider-container container-53 col-6">
        <div class="rappider-component">
          <!-- Component: Text 100 -->
          <rappider-text
            [textMode]="text_100.textMode"
            [text]="text_100.text"
            [content]="text_100.content"
            [typography]="text_100.typography"
            [colorSettings]="text_100.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 54 -->
      <div class="rappider-container container-54 col-6">
        <div class="rappider-component">
          <!-- Component: Text 101 -->
          <rappider-text
            [textMode]="text_101.textMode"
            [text]="text_101.text"
            [content]="text_101.content"
            [typography]="text_101.typography"
            [colorSettings]="text_101.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 102 -->
          <rappider-image
            [source]="image_102.source"
            [alternateText]="image_102.alternateText"
            [placeholder]="image_102.placeholder"
            [disablePreview]="image_102.disablePreview"
            [borderSettings]="image_102.borderSettings"
            [shadowSettings]="image_102.shadowSettings"
            [paddingSettings]="image_102.paddingSettings"
            [marginSettings]="image_102.marginSettings"
            [customSizeSettings]="image_102.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 103 -->
          <rappider-image
            [source]="image_103.source"
            [alternateText]="image_103.alternateText"
            [placeholder]="image_103.placeholder"
            [disablePreview]="image_103.disablePreview"
            [borderSettings]="image_103.borderSettings"
            [shadowSettings]="image_103.shadowSettings"
            [paddingSettings]="image_103.paddingSettings"
            [marginSettings]="image_103.marginSettings"
            [customSizeSettings]="image_103.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 104 -->
          <rappider-image
            [source]="image_104.source"
            [alternateText]="image_104.alternateText"
            [placeholder]="image_104.placeholder"
            [disablePreview]="image_104.disablePreview"
            [borderSettings]="image_104.borderSettings"
            [shadowSettings]="image_104.shadowSettings"
            [paddingSettings]="image_104.paddingSettings"
            [marginSettings]="image_104.marginSettings"
            [customSizeSettings]="image_104.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 105 -->
          <rappider-image
            [source]="image_105.source"
            [alternateText]="image_105.alternateText"
            [placeholder]="image_105.placeholder"
            [disablePreview]="image_105.disablePreview"
            [borderSettings]="image_105.borderSettings"
            [shadowSettings]="image_105.shadowSettings"
            [paddingSettings]="image_105.paddingSettings"
            [marginSettings]="image_105.marginSettings"
            [customSizeSettings]="image_105.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 106 -->
          <rappider-image
            [source]="image_106.source"
            [alternateText]="image_106.alternateText"
            [placeholder]="image_106.placeholder"
            [disablePreview]="image_106.disablePreview"
            [borderSettings]="image_106.borderSettings"
            [shadowSettings]="image_106.shadowSettings"
            [paddingSettings]="image_106.paddingSettings"
            [marginSettings]="image_106.marginSettings"
            [customSizeSettings]="image_106.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
